module.exports = __webpack_public_path__ + "media/images/feature-icons/feature-icon-4-6fa1e0869f816cbaa445ffed298f024c.svg";